import { useState, useEffect } from 'react'
import { Tooltip, Button, Upload } from 'antd'
import { RcFile } from 'antd/lib/upload'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImage } from '@fortawesome/pro-solid-svg-icons/faImage'
import { faClose } from '@fortawesome/pro-solid-svg-icons/faClose'
import { useTranslation } from 'react-i18next'
import {
  Wrapper,
  Container,
  Content,
  RemoveImage,
  Image,
  Title,
  Subtitle,
  IconWrapper,
} from './styled'

interface IProps {
  image: File | string | null
  setImage: (value: File | null) => void
}

const UploadImage = ({ image, setImage }: IProps) => {
  const { t } = useTranslation()
  const translatePrefix = 'administration.certificate.new.backgroundImage'
  const [file, setFile] = useState<string | null>(null)

  useEffect(() => {
    if (image === null) {
      setFile(null)
    } else {
      if (typeof image === 'string') {
        setFile(image)
      } else {
        setFile(URL.createObjectURL(image))
      }
    }
  }, [image])

  const beforeUpload = (newFile: RcFile) => {
    setImage(newFile)
    return false
  }

  return (
    <Wrapper>
      {file ? (
        <Container imageloaded="true">
          <RemoveImage>
            <Tooltip
              title={t(`${translatePrefix}.removeImage`)}
              placement="bottom"
            >
              <FontAwesomeIcon icon={faClose} onClick={() => setImage(null)} />
            </Tooltip>
          </RemoveImage>
          <Image url={file} />
        </Container>
      ) : (
        <Upload
          beforeUpload={(file: RcFile) => beforeUpload(file)}
          accept=".jpg, .jpeg, .png"
          showUploadList={false}
        >
          <Container imageloaded="false">
            <Content>
              <IconWrapper>
                <FontAwesomeIcon icon={faImage} />
              </IconWrapper>
              <Title>{t(`${translatePrefix}.allowedFormats`)}</Title>
              <Subtitle>{t(`${translatePrefix}.idealSize`)}</Subtitle>
              <Button type="link">{t(`${translatePrefix}.uploadImage`)}</Button>
            </Content>
          </Container>
        </Upload>
      )}
    </Wrapper>
  )
}

export default UploadImage
